<template>
<div>
    <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert_success" v-if="alert_show_add === true">เพิ่มหน่วยนับเรียบร้อย</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_show_edit === true">แก้ไขหน่วยนับเรียบร้อย</v-alert>
    </v-slide-x-reverse-transition>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <div class="d-flex justify-space-between card_stock_unit_list">
            <div class="mr-1">
                <v-form ref="form" @submit.prevent="addStockUnit()">
                    <div class="mb-2">
                        <h3>{{ edit_id !== null ? 'แก้ไข' : 'เพิ่ม'}}หน่วยนับ</h3>
                    </div>
                    <v-text-field label="ชื่อหน่วยนับ" v-model="name" :rules="[v => !!v || 'กรุณากรอกชื่อหน่วยนับ']" required outlined></v-text-field>
                    <v-btn color="#038cc1" class="titlefont_stock_unit_list white--text" width="100%" height="50" type="submit">
                        บันทึก
                    </v-btn>
                </v-form>
            </div>
            <div class="ml-1">
                <v-card>
                    <v-card-title>
                        <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
                    </v-card-title>
                    <v-data-table :headers="headers" :items="data" :search="search">
                        <template v-slot:item="dataDetail">
                            <tr>
                                <td>{{dataDetail.item.number}}</td>
                                <td>{{dataDetail.item.name}}</td>
                                <td>

                                    <span class="edit_data_stock_unit_list" @click="detailStockUnit(dataDetail.item.id)">
                                        <v-icon dark right color="grey">mdi-pencil-box-outline</v-icon>
                                    </span>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import stockunit from '@/api/stock/stocksetting/stockunit.js'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: false,
            alert_show_add: false,
            alert_show_edit: false,
            search: '',
            headers: [{
                    text: '#',
                    align: 'start',
                    value: 'number',
                },
                {
                    text: 'หน่วยนับ',
                    value: 'name'
                },
                {
                    text: 'แก้ไข',
                    value: 'action'
                },
            ],
            data: [],
            edit_id: null,
            name: null,
        }
    },
    methods: {
        async stockUnitList() {
            this.loading_page = true
            this.data = []
            stockunit.unitList().then((response) => {
                if (response.data.successful === true) {
                    this.data = response.data.list
                    response.data.list.forEach((detail, index) => {
                        this.data[index]['number'] = index + 1
                    })
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async detailStockUnit(id) {
            stockunit.detailUnit(id).then((response) => {
                if (response.data.successful === true) {
                    this.edit_id = response.data.detail.id
                    this.name = response.data.detail.name
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async addStockUnit() {
            if (this.$refs.form.validate()) {
                this.loading_page = true
                const data = {
                    unit_name: this.name,
                }
                if (!this.edit_id) {
                    stockunit.addUnit(data).then((response) => {
                        if (response.data.successful === true) {
                            this.edit_id = null
                            this.name = null
                            this.stockUnitList()
                            this.alert_show_add = true
                            setTimeout(() => this.alert_show_add = false, 5000)
                        }
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
                }
                if (this.edit_id) {
                    stockunit.editUnit(this.edit_id, data).then((response) => {
                        if (response.data.successful === true) {
                            this.edit_id = null
                            this.name = null
                            this.stockUnitList()
                            this.alert_show_edit = true
                            setTimeout(() => this.alert_show_edit = false, 5000)
                        }
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
                }

            }
        }
    },
    mounted() {
        this.stockUnitList()
    }
}
</script>

<style scoped>
.card_stock_unit_list>div:first-child {
    width: 30%;

}

.card_stock_unit_list>div:last-child {
    width: 70%;
}

.titlefont_stock_unit_list {
    font-size: 22px !important;
}

.edit_data_stock_unit_list {
    cursor: pointer;
}
</style>
